import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import {
  FormattedMessage,
} from 'react-intl'
import countries from './countriesList'

import '../../../../css/dropdown.module.css'

import {
  IsReq,
  Label,
  ContainerOptions,
  DropdownContainer,
} from './styledComponents'

const Dropdown = function Dropdown (props) {
  const {
    countryValue = -1,
    stateValue = -1,
    onCountryChange = () => {},
    onStateChange = () => {},
    hasError = () => {},
  } = props

  const states = useMemo(() => {
    if (countryValue < 0) {
      return []
    }

    const selectedCountry = countries[countryValue]
    return selectedCountry ? selectedCountry.states : []
  }, [countryValue])

  return (
    <div>
      <Label>
        <FormattedMessage
          id='auth.address.country'
          defaultMessage='Country'
          description='Country label'
        />
        <IsReq>
          *
        </IsReq>
      </Label>
      <DropdownContainer>
        <ContainerOptions
          value={countryValue > -1 ? String(countryValue) : ''}
          onChange={onCountryChange}
          error={hasError('country')}
          name='ship-country'
          autoComplete='shipping country'
          required
        >
          <option />
          {
            countries.map((countryItem, idx) => (
              <option key={countryItem.country} value={idx}>
                {countryItem.country}
              </option>
            ))
          }
        </ContainerOptions>
      </DropdownContainer>
      <Label>
        <FormattedMessage
          id='auth.address.state'
          defaultMessage='State/Region/Province'
          description='State/Region/Province label'
        />
        <IsReq>
          *
        </IsReq>
      </Label>
      <DropdownContainer>
        <ContainerOptions
          value={stateValue > -1 ? String(stateValue) : ''}
          onChange={onStateChange}
          error={hasError('state')}
          name='ship-state'
          autoComplete='shipping region'
          disabled={states.length === 0}
        >
          <option />
          {
            states.map((state, idx) => (
              <option key={state} value={idx}>
                {state}
              </option>
            ))
          }
        </ContainerOptions>
      </DropdownContainer>
    </div>
  )
}

Dropdown.propTypes = {
  countryValue: PropTypes.number,
  stateValue: PropTypes.number,
  onCountryChange: PropTypes.func,
  onStateChange: PropTypes.func,
  hasError: PropTypes.func,
}

Dropdown.defaultProps = {
  countryValue: -1,
  stateValue: -1,
  onCountryChange: () => {},
  onStateChange: () => {},
  hasError: () => false,
}

Dropdown.displayName = 'CountryStateDropdowns'

export default Dropdown
